AuthRoute = require 'mixins/authenticated-route'

App.BonusCategoriesCreateRoute = Em.Route.extend AuthRoute,
  controllerName: 'bonus-categories.edit'
  templateName:   'bonus-categories.edit'

  session: Em.inject.service()

  model: ->
    organization = @get('session.currentOrganization')

    unless organization
      return Em.RSVP.reject 'No current organization context found'

    @store.createRecord 'client-tag',
      name: ''
      organization: organization
      is_bonus_category: true
